import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Y42AgGridModule } from '@y42/ag-grid';
import { GitDiffTreeItemChangeCellRendererComponent } from './git-diff-tree-item-change-cell-renderer/git-diff-tree-item-change-cell-renderer.component';
import { GitDiffTreeItemFileCellRendererComponent } from './git-diff-tree-item-file-cell-renderer/git-diff-tree-item-file-cell-renderer.component';
import { GitDiffTreeItemGroupCellRendererComponent } from './git-diff-tree-item-group-cell-renderer/git-diff-tree-item-group-cell-renderer.component';
import { GitDiffTreeComponent } from './git-diff-tree.component';

@NgModule({
  imports: [CommonModule, Y42AgGridModule, MatButtonModule, MatTooltipModule, MatProgressBarModule, FontAwesomeModule],
  declarations: [
    GitDiffTreeComponent,
    GitDiffTreeItemChangeCellRendererComponent,
    GitDiffTreeItemGroupCellRendererComponent,
    GitDiffTreeItemFileCellRendererComponent,
  ],
  exports: [GitDiffTreeComponent],
})
export class GitDiffTreeModule {}
